<template>
  <div class="head_box">
    <div></div>
    <div class="action_box">
      <el-button
        type="text"
        style="color: #ffffff"
        @click="toPeopleCenter"
        v-if="$store.state.userInfo"
        >{{ $store.state.userInfo.userIdStr }} -
        {{ $store.state.userInfo.companyName }}
      </el-button>
      <div
        v-if="$store.state.userInfo"
        style="
          margin: 0 12px;
          color: #ffffff;
          padding-right: 10px;
          border-right: 1px solid #78808d;
          cursor: pointer;
          width: 2px;
          height: 20px;
          display: flex;
        "
      ></div>
      <el-button
        type="text"
        style="color: #ffffff"
        @click="toRegister"
        v-if="!$store.state.userInfo"
        >注册</el-button
      >
      <el-button type="text" style="color: #ffffff" @click="toExit" v-else
        >退出</el-button
      >
      <el-button type="text" style="color: #ffffff" @click="toHome">网站首页</el-button>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    toRegister() {
      this.$router.push({
        name: "register",
      });
    },
    toHome() {
      this.$router.push({
        name: "Home",
      });
    },
    toExit() {
      this.$store.commit("CLEAR_VUEX");
      this.toHome();
    },
    toPeopleCenter() {
      this.$store.commit("UPDATE_ACTIVE_MENU", '6-1');
      this.$router.push({
        name: "manegeCenter",
      });
    },
  },
};
</script>

<style lang="less">
.head_box {
  width: 100%;
  height: 30px;
  z-index: 100;
  background: #232830;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .action_box {
    margin-right: 70px;
    display: flex;
    align-items: center;
  }
}
</style>